export function getColorHex(clCd: string): string {
  return COLOR_LIST[clCd]?.colorHex.toUpperCase() ?? "";
}

const COLOR_LIST: { [key: string]: { name: string; colorHex: string } } = {
  "00": { name: "WHITE", colorHex: "#ffffff" },
  "01": { name: "OFF WHITE", colorHex: "#ffffe6" },
  "02": { name: "LIGHT GRAY", colorHex: "#cccccc" },
  "03": { name: "GRAY", colorHex: "#999999" },
  "04": { name: "GRAY", colorHex: "#999999" },
  "05": { name: "GRAY", colorHex: "#999999" },
  "06": { name: "GRAY", colorHex: "#999999" },
  "07": { name: "GRAY", colorHex: "#999999" },
  "08": { name: "DARK GRAY", colorHex: "#4c4c4c" },
  "09": { name: "BLACK", colorHex: "#000000" },
  "10": { name: "PINK", colorHex: "#ff3399" },
  "11": { name: "PINK", colorHex: "#ff3399" },
  "12": { name: "PINK", colorHex: "#ff3399" },
  "13": { name: "RED", colorHex: "#ff0000" },
  "14": { name: "RED", colorHex: "#ff0000" },
  "15": { name: "RED", colorHex: "#ff0000" },
  "16": { name: "RED", colorHex: "#ff0000" },
  "17": { name: "RED", colorHex: "#ff0000" },
  "18": { name: "WINE", colorHex: "#6b0032" },
  "19": { name: "WINE", colorHex: "#6b0032" },
  "20": { name: "LIGHT ORANGE", colorHex: "#ffc900" },
  "21": { name: "LIGHT ORANGE", colorHex: "#ffc900" },
  "22": { name: "ORANGE", colorHex: "#ffa500" },
  "23": { name: "ORANGE", colorHex: "#ffa500" },
  "24": { name: "ORANGE", colorHex: "#ffa500" },
  "25": { name: "ORANGE", colorHex: "#ffa500" },
  "26": { name: "ORANGE", colorHex: "#ffa500" },
  "27": { name: "ORANGE", colorHex: "#ffa500" },
  "28": { name: "DARK ORANGE", colorHex: "#f07800" },
  "29": { name: "DARK ORANGE", colorHex: "#f07800" },
  "30": { name: "NATURAL", colorHex: "#d1c2a5" },
  "31": { name: "BEIGE", colorHex: "#f5f5dc" },
  "32": { name: "BEIGE", colorHex: "#f5f5dc" },
  "33": { name: "KHAKI", colorHex: "#f0e68c" },
  "34": { name: "BROWN", colorHex: "#a52a2a" },
  "35": { name: "BROWN", colorHex: "#a52a2a" },
  "36": { name: "BROWN", colorHex: "#a52a2a" },
  "37": { name: "BROWN", colorHex: "#a52a2a" },
  "38": { name: "DARK BROWN", colorHex: "#da0b00" },
  "39": { name: "DARK BROWN", colorHex: "#da0b00" },
  "40": { name: "CREAM", colorHex: "#fffcd0" },
  "41": { name: "YELLOW", colorHex: "#ffff00" },
  "42": { name: "YELLOW", colorHex: "#ffff00" },
  "43": { name: "YELLOW", colorHex: "#ffff00" },
  "44": { name: "YELLOW", colorHex: "#ffff00" },
  "45": { name: "YELLOW", colorHex: "#ffff00" },
  "46": { name: "YELLOW", colorHex: "#ffff00" },
  "47": { name: "YELLOW", colorHex: "#ffff00" },
  "48": { name: "YELLOW", colorHex: "#ffff00" },
  "49": { name: "MUSTARD", colorHex: "#ffd700" },
  "50": { name: "LIGHT GREEN", colorHex: "#90ee90" },
  "51": { name: "GREEN", colorHex: "#008000" },
  "52": { name: "GREEN", colorHex: "#008000" },
  "53": { name: "GREEN", colorHex: "#008000" },
  "54": { name: "GREEN", colorHex: "#008000" },
  "55": { name: "GREEN", colorHex: "#008000" },
  "56": { name: "OLIVE", colorHex: "#808000" },
  "57": { name: "OLIVE", colorHex: "#808000" },
  "58": { name: "DARK GREEN", colorHex: "#006400" },
  "59": { name: "DARK GREEN", colorHex: "#006400" },
  "60": { name: "LIGHT BLUE", colorHex: "#bfd5ff" },
  "61": { name: "BLUE", colorHex: "#0000ff" },
  "62": { name: "BLUE", colorHex: "#0000ff" },
  "63": { name: "BLUE", colorHex: "#0000ff" },
  "64": { name: "BLUE", colorHex: "#0000ff" },
  "65": { name: "BLUE", colorHex: "#0000ff" },
  "66": { name: "BLUE", colorHex: "#0000ff" },
  "67": { name: "BLUE", colorHex: "#0000ff" },
  "68": { name: "BLUE", colorHex: "#0000ff" },
  "69": { name: "NAVY", colorHex: "#000080" },
  "70": { name: "LIGHT PURPLE", colorHex: "#9370db" },
  "71": { name: "PURPLE", colorHex: "#8b008b" },
  "72": { name: "PURPLE", colorHex: "#8b008b" },
  "73": { name: "PURPLE", colorHex: "#8b008b" },
  "74": { name: "PURPLE", colorHex: "#8b008b" },
  "75": { name: "PURPLE", colorHex: "#8b008b" },
  "76": { name: "PURPLE", colorHex: "#8b008b" },
  "77": { name: "PURPLE", colorHex: "#8b008b" },
  "78": { name: "PURPLE", colorHex: "#8b008b" },
  "79": { name: "DARK PURPLE", colorHex: "#800080" },
  "99": { name: "Other", colorHex: "#b2b2b2" },
};
